import {
  useIsAuthenticated,
  useIsInitLoading,
  useIsLoggedIn,
} from '@core-frontend/core-frontend';
import { useEffect, useState } from 'react';
import { Navigate, Outlet, useLocation, useNavigate } from 'react-router-dom';

import { getUserInfoAndUpdateStore } from '@/pages/auth/model';

import { AppRoutes } from '../AppRoutes';

const AuthenticatedGuard = () => {
  const isLoggedIn = useIsLoggedIn();
  const isAuth = useIsAuthenticated();
  const isLoading = useIsInitLoading();
  const navigate = useNavigate();
  const [initialLocation, setInitialLocation] = useState<string | null>(null);
  const location = useLocation();

  useEffect(() => {
    if (isLoggedIn && !isAuth && !isLoading) {
      getUserInfoAndUpdateStore();
    }
  }, [isLoggedIn, isAuth, isLoading]);

  useEffect(() => {
    if (isLoggedIn && initialLocation) {
      // Redirect to the initial location after successful login
      navigate(initialLocation, { replace: true });
      setInitialLocation(null);
    }
  }, [isLoggedIn, initialLocation, navigate]);
  if (!isLoggedIn) {
    if (initialLocation === null) {
      setInitialLocation(location.pathname);
    }
    return <Navigate to={AppRoutes.LOGIN} state={{ from: location }} replace />;
  }

  return <Outlet />;
};

export default AuthenticatedGuard;
